'use client'
import '../style'
import '../initializer'

import { HomeFilled } from '@ant-design/icons'
import { Divider, Typography } from 'antd'
import { createStyles } from 'antd-style'

import { system } from '@eastcoal/common/config/system'

import { RouterLink } from '@eastcoal/router/components/Link'
import { RouterOutlet } from '@eastcoal/router/components/Outlet'
import { EastcoalLogo } from '@eastcoal/shared/components/EastcoalLogo'
import { GlobalHeader } from '@eastcoal/shared/components/GlobalHeader'

import { LayoutFooter } from './components/Footer'
import { LayoutSearch } from './components/Search'

const useStyles = createStyles(({ token }) => ({
  container: {
    backgroundColor: token.colorBgLayout
  },
  topbar: {
    position: 'sticky',
    top: 0,
    zIndex: token.zIndexPopupBase
  },
  globalHeaderWrapper: {
    backgroundColor: token.colorBgLayout
  },
  globalHeader: {
    width: token.layoutContentWidth,
    marginInline: 'auto'
  },
  pageHeaderWrapper: {
    backgroundColor: token.colorWhite,
    boxShadow: `0px 4px 4px 0px rgba(0,50,184,0.1)`
  },
  pageHeader: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    height: 64,
    width: token.layoutContentWidth,
    marginInline: 'auto'
  },
  homeLinkIcon: {
    marginRight: token.marginXS
  },
  logoDivider: {
    height: '2em',
    borderColor: token.colorBorder,
    marginInline: token.marginMD
  },
  main: {
    width: token.layoutContentWidth,
    marginInline: 'auto'
  }
}))

export const SupportLayout = () => {
  const { styles } = useStyles()

  return (
    <div className={styles.container}>
      <div className={styles.topbar}>
        <div className={styles.globalHeaderWrapper}>
          <GlobalHeader showMallCenter className={styles.globalHeader}>
            <RouterLink to={system.router.mallBaseUrl}>
              <HomeFilled className={styles.homeLinkIcon} />
              <span>前往商城首页</span>
            </RouterLink>
          </GlobalHeader>
        </div>
        <div className={styles.pageHeaderWrapper}>
          <div className={styles.pageHeader}>
            <EastcoalLogo />
            <Divider className={styles.logoDivider} orientation='vertical' />
            <Typography.Text>帮助中心</Typography.Text>
          </div>
        </div>
      </div>
      <div className={styles.main}>
        <LayoutSearch />
        <RouterOutlet />
      </div>
      <LayoutFooter />
    </div>
  )
}
